import { createContext } from 'react';

/** What a page says about itself in the document head. */
export type PageHead = { title: string; description: string; noindex: boolean; path: string };

/**
 * Where the prerenderer collects each page's head. `entry-server.tsx` provides it, so the same
 * `<Seo>` a page renders on the client decides the `<title>`, description and robots tag of its
 * prerendered HTML: there is no second table of titles to keep in step with the pages. Absent on
 * the client, where the effect below keeps the live head current instead.
 */
export const HeadContext = createContext<{ collect(head: PageHead): void } | null>(null);
